module.exports = __webpack_public_path__ + "img/ic_tip_fail.70a2bdbc.png";